import { makeStyles } from '@material-ui/core';
import React, { memo } from 'react';
import { dateMomentFormat } from 'v2/formatters/date';

import type { ISubscriptions } from 'v2/interfaces/subscriptions';

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: '#eee',
    height: 140,
  },
}));
interface IProps {
  contract: ISubscriptions;
}

const ContractDetails = memo(({ contract }: IProps) => {
  const classes = useStyles();

  if (!contract) {
    return null;
  }

  return (
    <div className={classes.root}>
      <div className='my-list my-list--text -wtotal'>
        <div className='my-list__table btransparent'>
          <div className='my-list__container'>
            <div className='my-list__row my-list__row--boxes -wmwidth'>
              <div className='my-list__col'>
                Código <span>{contract?.id}</span>
              </div>
              <div className='my-list__col'>
                {contract?.created_at && (
                  <div className='my-list__col'>
                    Ativação
                    <span>{dateMomentFormat(contract?.initial_date)}</span>
                  </div>
                )}
              </div>
              <div className='my-list__col'>
                {contract?.created_at && (
                  <div className='my-list__col'>
                    Criação
                    <span>{dateMomentFormat(contract?.created_at)}</span>
                  </div>
                )}
              </div>
            </div>
            <div className='my-list__row my-list__row--boxes -wmwidth'>
              {contract?.received_at && (
                <div className='my-list__col'>
                  Ult.Cobrança
                  <span>{dateMomentFormat(contract?.received_at)}</span>
                </div>
              )}
            </div>
            <div className='my-list__row my-list__row--boxes -wmwidth'>
              <div className='my-list__col'>
                Status
                <span title={contract?.payment_status && contract?.payment_status.name}>
                  {contract?.payment_status &&
                    contract?.payment_status.id !== 6 &&
                    contract?.payment_status.id !== 15 &&
                    contract?.payment_status.name}
                  {contract?.payment_status && contract?.payment_status.id === 6 && 'Ag. Reembolso'}
                  {contract?.payment_status && contract?.payment_status.id === 15 && 'Ag. Pagamento'}
                </span>
              </div>
              <div className='my-list__col'>
                {contract?.canceled_at && contract?.payment_status.id === 4 && (
                  <div className='my-list__col'>
                    Cancelamento
                    <span>{dateMomentFormat(contract?.canceled_at)}</span>
                  </div>
                )}
              </div>
              <div className='my-list__col'></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ContractDetails;
